import { getRem } from '@arpia/utils';
import { styled, css } from 'twin.macro';

export const StyledPageLoader = styled.div(() => [
  css`
    height: calc(100vh - ${getRem(180)});
  `
]);
